import { COUNTRY_CODE, COUNTRY_CODE_ISO_2, COUNTRY_CURRENCY, COUNTRY_LANG } from '@core/enums';

export interface ICountry {
  code: COUNTRY_CODE;
  language: COUNTRY_LANG;
  iso: COUNTRY_CODE_ISO_2;
  currency: COUNTRY_CURRENCY;
  hasDecimal: boolean;
  active: boolean;
}
